export default __webpack_public_path__ + "static/image-7aa5962fa5991b3653f225f2912a801a.png";